module.exports = __webpack_public_path__ + "static/assets/f2adf12644f88d04104fb8c18fdc355c.svg";